import { Clickable, Col, Icon, MediaModal, Row, Text } from 'components';
import { imageResizer } from 'core';
import mime from 'mime';
import React, { useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import { useDispatch } from 'react-redux';
import { RemoveButton } from 'screens/Admin/components';
import styled from 'styled-components';

const Preview = styled.div`
  position: relative;
  border: 1px solid #ddd;
  border-radius: 7px;
  background-image: ${(props) => `url(${props.img})`};
  width: 120px;
  height: 120px;
  z-index: 1;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;

const Media = ({ media, setMedia, error, isEditing, isProcessing }) => {
  const [previews, setPreviews] = useState([]),
    firstMedia = media?.length && media[0],
    firstMediaType =
      mime.getType(firstMedia) ||
      mime.getType(firstMedia?.uri) ||
      mime.getType(firstMedia?.file?.name),
    isVideo =
      (typeof firstMediaType === 'string' && firstMediaType?.includes('m3u8')) ||
      firstMediaType?.includes('video'),
    imageInput = useRef(),
    videoInput = useRef(),
    dispatch = useDispatch();

  async function handleFile(e) {
    const files = Array.from(e?.target?.files);
    imageInput.current.value = '';
    videoInput.current = '';
    if (!files.length) return;

    const hasVideo = files.find((x) => x.type.includes('video'));

    if (hasVideo) {
      if (hasVideo.size >= 104857600) {
        dispatch({
          type: 'HANDLE_RES',
          payload: { err: 'Video cannot be larger than 100 MB.' }
        });

        return;
      }

      setMedia([
        {
          uri: URL.createObjectURL(hasVideo),
          file: hasVideo
        }
      ]);

      return;
    }

    let mapped = Array.from(media);

    for await (let file of files) {
      if ((mapped?.length || 0) >= 10) break;

      const uri = await imageResizer({
        height: 1080,
        width: 1080,
        format: 'jpeg',
        file,
        output: 'blob',
        quality: 70
      });

      const thumbnail = await imageResizer({
        height: 300,
        width: 300,
        format: 'jpeg',
        file,
        output: 'blob',
        quality: 100
      });

      mapped.push({ uri, thumbnail, preview: URL.createObjectURL(uri) });
    }

    setMedia(mapped);
  }

  function removeFile(idx) {
    if (isVideo) {
      setMedia([]);

      return;
    }

    setMedia(media.filter((x, i) => i !== idx));
  }

  return (
    <Col noFlex>
      <Text marg="24px 16px 5px" b2 med>
        Media
      </Text>

      <Col>
        {isProcessing ? (
          <Text med>Processing the video...</Text>
        ) : (
          <React.Fragment>
            <input
              multiple
              type="file"
              ref={imageInput}
              accept="image/*"
              style={{ width: 0, height: 0, opacity: 0 }}
              onChange={(event) => handleFile(event)}
            />

            <input
              multiple
              type="file"
              ref={videoInput}
              accept="video/*"
              style={{ width: 0, height: 0, opacity: 0 }}
              onChange={(event) => handleFile(event)}
            />

            {!!isVideo && (
              <Col pos="relative" bg="#000">
                <RemoveButton onClick={() => removeFile()} />

                <ReactPlayer url={media && media[0]?.uri} style={{ maxWidth: 552 }} controls />
              </Col>
            )}

            {!!media?.length && !isVideo && (
              <Row gap="21px" start wrapFlex>
                {media?.map((x, i) => (
                  <Col pos="relative" noFlex key={i}>
                    <RemoveButton onClick={() => removeFile(i)} />

                    <MediaModal media={x.preview || x.uri}>
                      <Preview img={x.preview || x.uri}></Preview>
                    </MediaModal>
                  </Col>
                ))}

                {!!((media?.length || 0) < 10) && (
                  <Col noFlex center>
                    <Clickable onClick={() => imageInput.current.click()}>
                      <Row center marg="0 0 0 32px">
                        <Icon type="add" dimensions={12} marg="0 6px 0 0" />

                        <Text>Add</Text>
                      </Row>
                    </Clickable>
                  </Col>
                )}
              </Row>
            )}
          </React.Fragment>
        )}

        {!media?.length && !isProcessing && (
          <Col marg="7px 0 0">
            <Clickable onClick={() => imageInput.current.click()}>
              <Row center>
                <Icon type="camera" dimensions="24" />

                <Text b2 marg="0 0 0 8px">
                  Add images
                </Text>
              </Row>
            </Clickable>

            <Clickable marg="12px 0 0" onClick={() => videoInput.current.click()}>
              <Row center>
                <Icon type="videoCamera" dimensions="24" />

                <Text b2 marg="0 0 0 8px">
                  Add video
                </Text>
              </Row>
            </Clickable>
          </Col>
        )}
      </Col>
    </Col>
  );
};

export default Media;
